import { render, staticRenderFns } from "./EmbedEntry.vue?vue&type=template&id=49d3bc92&scoped=true&"
import script from "./EmbedEntry.vue?vue&type=script&lang=js&"
export * from "./EmbedEntry.vue?vue&type=script&lang=js&"
import style0 from "./EmbedEntry.vue?vue&type=style&index=0&id=49d3bc92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3bc92",
  null
  
)

component.options.__file = "EmbedEntry.vue"
export default component.exports